<template>
  <div class="card" v-show="currentCardId == 'recommend'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>推薦・紹介を依頼</h2>
        <p>就労支援施設に障がいの詳細の記載と推薦文作成を依頼しましょう</p>
        <p style="color: red">
          ※推薦・紹介文が作成されたら、上記のメールアドレスにお知らせいたします。
        </p>
        <p style="color: red">
          ※推薦・紹介文を依頼せずにオファーを受けることも可能です。
        </p>
      </div>
      <div class="card-content">
        <div style="display: inline-block; min-width: 100%; text-align: center">
          <br />
          <p
            style="
              font-size: 120%;
              font-weight: bold;
              text-align: left;
              margin-bottom: 10px;
            "
          >
            お願いする相手の情報
          </p>
          <div
            style="display: inline-block; min-width: 100%; text-align: center"
          >
            <p style="font-size: 100%; text-align: left">
              就労支援事業所または施設名：<br />
              <el-input
                class="input-md"
                placeholder=""
                title="就労支援事業所または施設名"
                v-model="formatData.introName"
                type="email"
              />
            </p>
          </div>
          <br />
          <div
            style="display: inline-block; min-width: 100%; text-align: center"
          >
            <p style="font-size: 100%; text-align: left">
              メールアドレス：<br />
              <el-input
                class="input-md"
                placeholder=""
                title="メールアドレス"
                v-model="formatData.introEmail"
                type="email"
              />
            </p>
          </div>
          <br />
          <div
            style="display: inline-block; min-width: 100%; text-align: center"
          >
            <p style="font-size: 100%; text-align: left">
              関係：<br />
              <el-select
                v-model="formatData.relationship"
                placeholder="選択してください"
              >
                <el-option
                  v-for="item in esfOptions.relationshipOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </p>
          </div>
          <br />
          <div
            style="display: inline-block; min-width: 100%; text-align: center"
          >
            <p style="font-size: 100%; text-align: left">
              <span>作成期限は依頼してから２週間後になります。</span>
            </p>
          </div>
          <br />
          <div
            style="display: inline-block; min-width: 100%; text-align: center"
          >
            <br />
            <p style="font-size: 100%; text-align: left">
              お願い内容：<el-button
                type="success"
                @click="sampleVisible = true"
                >例文から追加</el-button
              ><br />
              <br />
              <NewRirekishoExampleSentenceDialog
                :value="sampleVisible"
                name="requestsample-dialog"
                :items="esfOptions.exampleRequestStatements"
                show-overwrite-warning
                @input="sampleVisible = $event"
                @select="onSelectSample"
              />
              <el-input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 15 }"
                v-model="formatData.requestStatement"
              />
            </p>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import type { RirekishoExampleSentence } from '@/composables/format-edit/useRirekishoFormatData'
import esfOptions from '@/utils/format-edit/rirekishoEsfOptions.json'

defineProps<{
  currentCardId?: string
}>()

const formatData = useRirekishoFormatData()
const sampleVisible = ref(false)

function onSelectSample(item: RirekishoExampleSentence) {
  formatData.requestStatement += item.description.replace(/<br>/gi, '\n') + '\n'
}
</script>
